module.exports = __webpack_public_path__ + "sd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sd.svg
// module id = 794
// module chunks = 0